import { HARD_BACK_BUTTON_CLICKED } from 'mini-mail-workflow-tracking/lib/constants/ListViewWorkflowConstants';
import { isFullComposeShown } from 'mini-mail-compose-store';
import { logUsage } from 'owa-analytics';
import { signalWorkflowEvent } from 'mini-workflow-manager';
import {
    lazyLoadDraftToCompose,
    lazyNewMessage,
    lazyDiscardCompose,
    lazyDeleteComposeDraft,
} from 'mini-mail-compose-actions-mail';

export interface MailComposeRouteParameters {
    draftId: string;
}

/**
 *  Handle view state creation task for compose.
 */
export async function composeRouterHandler(params: MailComposeRouteParameters) {
    if (isFullComposeShown()) {
        // If compose viewState is available, load the compose from viewState.
        return;
    } else if (params.draftId) {
        // on compose draft message
        await lazyLoadDraftToCompose(params.draftId);
    } else {
        (await lazyNewMessage.import())();
    }
}

/**
 *  Handle cleanup task for compose.
 */
export async function composeCleanupRouteHandler(): Promise<boolean> {
    logUsage(HARD_BACK_BUTTON_CLICKED, ['Compose_View']);
    signalWorkflowEvent(HARD_BACK_BUTTON_CLICKED);

    // If state is dirty, context menu is used to get the confirmation from user.
    const onComposeDraftDelete = async (itemId: string) =>
        (await lazyDeleteComposeDraft.import())(itemId);
    (await lazyDiscardCompose.import())({
        customComposeDraftDelete: onComposeDraftDelete,
    });
    // disable navigation if composeStore is non empty
    return isFullComposeShown();
}
